import React from 'react';
import styles from './fields.module.css';

interface TextFieldProps {
  value: string | undefined;
  setValue: (v: string) => void;
  fieldType?: 'text' | 'number' | 'date' | 'datetime';
  placeholder?: string;
  style?: React.CSSProperties;
}

const TextField: React.FC<TextFieldProps> = ({
  value,
  setValue,
  fieldType,
  placeholder,
  style,
}) => (
  <input
    placeholder={placeholder ?? ''}
    className={styles.textInput}
    value={value ?? ''}
    type={fieldType === 'datetime' ? 'datetime-local' : fieldType ?? 'text'}
    onChange={e => setValue(e.target.value)}
    style={style}
  />
);

export default TextField;
